import type FieldId from "../fields/FieldId";

/* Used for sending events to other Editor contexts (such as the Subform Drawer)  */
class FieldShowEvent extends Event {
  static eventName = "field.show";
  public readonly fieldId: FieldId;

  constructor(fieldId: FieldId) {
    super(FieldShowEvent.eventName, { bubbles: false });
    this.fieldId = fieldId;
  }

  send() {
    setTimeout(() => document.dispatchEvent(this));
  }
}

export default FieldShowEvent;
